import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid2,
    IconButton,
    TextField,
    useTheme,
} from "@mui/material";
import * as React from "react";
import { IoMdClose } from "react-icons/io";
import { useUpdateManpowerStatusMutation } from "store/slices/apis/manpowerSlice";

export default function ApproveManpowerComponent(props) {
    const {
        open,
        cancel,
        rowData,
        fullObjectData,
        type,
        openNotification,
        refetch,
    } = props;
    const theme = useTheme();
    const [comment, setComment] = React.useState("");

    const [updateManpowerStatus, updateManpowerStatusRes] = useUpdateManpowerStatusMutation();
    const handleApprove = () => {

        const formdata = new FormData();
        formdata.append("Status", "Approved");
        formdata.append("Id", rowData?.id);

        updateManpowerStatus(formdata);
    };

    React.useEffect(() => {
        if (updateManpowerStatusRes?.isSuccess) {
            if (updateManpowerStatusRes?.data?.status == "Success") {
                openNotification(updateManpowerStatusRes?.data?.message, "success");
                setComment("");
                cancel();
            } else {
                openNotification(updateManpowerStatusRes?.data?.message, "error");
            }
        }
    }, [updateManpowerStatusRes?.isSuccess]);
    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={cancel}
                disableEnforceFocus
                disableRestoreFocus
                aria-labelledby="draggable-dialog-title"
                fullWidth={true}
                maxWidth={"sm"}
            >
                <DialogTitle
                    sx={{
                        fontWeight: 500,
                        fontSize: "20px",
                        color: "#252525",
                        paddingBottom: 0,
                    }}
                    id="draggable-dialog-title"
                >
                    Approve
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={cancel}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    }}
                >
                    <IoMdClose style={{ fontSize: "20px" }} />
                </IconButton>
                <DialogContent>
                    <DialogContentText
                        sx={{ fontWeight: 400, fontSize: "16px", color: "#474747" }}
                    >
                        Are you sure you want to approve this Actual Quantity and Actual Manpower? This action is permanent.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={handleApprove}
                        loading={updateManpowerStatusRes?.isLoading}
                        sx={{
                            backgroundColor: `${theme?.customSettings?.themeColor}`,
                            color: "#fff",
                            fontSize: "16px",
                            fontWeight: "500",
                            textTransform: "none",
                        }}
                    >
                        Approve
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
